import AsideMenu from "components/asideMenu/AsideMenu";
import React, { useEffect, useRef, useState } from "react";
import Nav from "react-bootstrap/Nav";
import { useDispatch } from "react-redux";
import { useAuthHook } from "hooks/auth/useAuthHook";
import { useThemeHook } from "hooks/profile/useThemeHook";
import { perimssionsActions } from "store/actions/permissions";
import { logoutUserTokenAction } from "store/actions/token";
import { rememberMe } from "utils/functions";
import { useProfileHook } from "hooks/profile/useProfileHook";
import NotificationBox from "./NotificationBox";
import PropTypes from "prop-types";

function Header({ showBlur }) {
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState(false);
  const { userData } = useProfileHook();
  const { logoutUser, resetAuthData, resetLogoutData } = useAuthHook();

  const { updateHtmlTag, THEMES } = useThemeHook();
  const notificationRef = useRef(null);

  /******************* 
    @purpose : Used to logout 
    @Parameter : {} 
    @Author : INIC
    ******************/
  const logoutHandler = async () => {
    try {
      await logoutUser();
    } catch {
    } finally {
      resetLogoutData();
      resetAuthData();
      rememberMe();
      updateHtmlTag(THEMES.LIGHT);
      dispatch(logoutUserTokenAction());
      dispatch(
        perimssionsActions({
          modules: [],
          formatedModulesData: {},
          slug: "",
          _id: "",
          role: "",
          isModuleLoading: true,
        })
      );
    }
  };

  // Adding class to body element when sidebar toggles
  const [floatingSideBar, setFloatingSideBar] = useState(true);
  const handleToggle = () => {
    if (floatingSideBar) {
      setFloatingSideBar(false);
      document.body.classList.add("sidebar-collapsed");
    } else {
      setFloatingSideBar(true);
      document.body.classList.remove("sidebar-collapsed");
    }
  };
  /*****
  @purpose : Remove side bar collapsed class when aside backdrop div is called
  @Parameter : {}
  @Author : INIC
 */
  const handleSidebarClose = () => {
    if (document?.body?.classList.contains("sidebar-collapsed")) {
      setFloatingSideBar(true);
      document.body.classList.remove("sidebar-collapsed");
    }
  };

  // Close notification when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target) &&
        !event.target.closest(".inic-notifications-active")
      ) {
        setToggle(false);
      }
    }

    if (toggle) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [toggle]);
  return (
    <>
      <header className={`global-header${showBlur ? " show-blur" : ""}`}>
        <div className="toggle-sidebar">
          <a onClick={() => handleToggle()}>
            <span className="inic inic-menu"></span>
          </a>
        </div>
        <div className="nav-right">
          <Nav className="nav-menus">
            <Nav.Item className={userData?.data?.unreadNotificationCount > 0 && "new-notification"}>
              <Nav.Link className="link-dark">
                <span className="inic inic-notifications-active" onClick={() => setToggle(!toggle)}></span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link className="link-danger">
                <span className="inic inic-power-off" onClick={logoutHandler}></span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
      </header>
      <AsideMenu showBlur={showBlur} handleSidebarClose={handleSidebarClose} />
      {toggle && (
        <div ref={notificationRef}>
          <NotificationBox setToggle={setToggle} />
        </div>
      )}
    </>
  );
}

Header.propTypes = {
  showBlur: PropTypes.bool,
};

export default Header;
